/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.5.0 (NJsonSchema v10.6.6.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const FeatureAvailabilityBaseApiUrl = new InjectionToken<string>('FeatureAvailabilityBaseApiUrl');

@Injectable({
    providedIn: 'root'
})
export class FeatureAvailabilityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(FeatureAvailabilityBaseApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5315";
    }

    getFeatureList(): Observable<Feature[]> {
        let url_ = this.baseUrl + "/feature-availability/v1/Feature";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeatureList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeatureList(<any>response_);
                } catch (e) {
                    return <Observable<Feature[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Feature[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFeatureList(response: HttpResponseBase): Observable<Feature[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Feature.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Feature[]>(<any>null);
    }

    getUserHasAccess(accessRequest: AccessRequestModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/feature-availability/v1/Feature/access";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accessRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserHasAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserHasAccess(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserHasAccess(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    getUserHasAccessByStoreNumber(accessRequest: AccessByStoreNumberRequestModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/feature-availability/v1/Feature/accessByStoreNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accessRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserHasAccessByStoreNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserHasAccessByStoreNumber(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserHasAccessByStoreNumber(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    auditUserAccessWithAccountLocation(userId: number, featureId: string | null, storeNumber?: number | null | undefined, accountId?: number | null | undefined): Observable<FeatureRequirementViewModel[]> {
        let url_ = this.baseUrl + "/feature-availability/v1/Feature/audit/{featureId}/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (featureId === undefined || featureId === null)
            throw new Error("The parameter 'featureId' must be defined.");
        url_ = url_.replace("{featureId}", encodeURIComponent("" + featureId));
        if (storeNumber !== undefined && storeNumber !== null)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (accountId !== undefined && accountId !== null)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuditUserAccessWithAccountLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuditUserAccessWithAccountLocation(<any>response_);
                } catch (e) {
                    return <Observable<FeatureRequirementViewModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FeatureRequirementViewModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processAuditUserAccessWithAccountLocation(response: HttpResponseBase): Observable<FeatureRequirementViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FeatureRequirementViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeatureRequirementViewModel[]>(<any>null);
    }

    auditUserAccessWithAccountStore(userId: number, featureId: string | null, storeNumber?: string | null | undefined, accountId?: number | null | undefined): Observable<FeatureRequirementViewModel[]> {
        let url_ = this.baseUrl + "/feature-availability/v1/Feature/auditByStoreNumber/{featureId}/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (featureId === undefined || featureId === null)
            throw new Error("The parameter 'featureId' must be defined.");
        url_ = url_.replace("{featureId}", encodeURIComponent("" + featureId));
        if (storeNumber !== undefined && storeNumber !== null)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (accountId !== undefined && accountId !== null)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuditUserAccessWithAccountStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuditUserAccessWithAccountStore(<any>response_);
                } catch (e) {
                    return <Observable<FeatureRequirementViewModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FeatureRequirementViewModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processAuditUserAccessWithAccountStore(response: HttpResponseBase): Observable<FeatureRequirementViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FeatureRequirementViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeatureRequirementViewModel[]>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserFeatureAvailabilityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(FeatureAvailabilityBaseApiUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5315";
    }

    getUserAccess(requestModel: UserAccessRequestModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/feature-availability/v1/UserFeature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAccess(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserAccess(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    getUserAccessByStoreNumber(requestModel: UserAccessByStoreNumberRequestModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/feature-availability/v1/UserFeature/byStore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAccessByStoreNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAccessByStoreNumber(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserAccessByStoreNumber(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }
}

export class Feature implements IFeature {
    id?: string | null;
    name?: string | null;
    description?: string | null;
    accountRequired?: boolean;
    locationRequired?: boolean;
    allowAny?: boolean;

    constructor(data?: IFeature) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.accountRequired = _data["accountRequired"] !== undefined ? _data["accountRequired"] : <any>null;
            this.locationRequired = _data["locationRequired"] !== undefined ? _data["locationRequired"] : <any>null;
            this.allowAny = _data["allowAny"] !== undefined ? _data["allowAny"] : <any>null;
        }
    }

    static fromJS(data: any): Feature {
        data = typeof data === 'object' ? data : {};
        let result = new Feature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["accountRequired"] = this.accountRequired !== undefined ? this.accountRequired : <any>null;
        data["locationRequired"] = this.locationRequired !== undefined ? this.locationRequired : <any>null;
        data["allowAny"] = this.allowAny !== undefined ? this.allowAny : <any>null;
        return data;
    }

    clone(): Feature {
        const json = this.toJSON();
        let result = new Feature();
        result.init(json);
        return result;
    }
}

export interface IFeature {
    id?: string | null;
    name?: string | null;
    description?: string | null;
    accountRequired?: boolean;
    locationRequired?: boolean;
    allowAny?: boolean;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions?: { [key: string]: any; };

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key] !== undefined ? _data["extensions"][key] : <any>null;
                }
            }
            else {
                this.extensions = <any>null;
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = this.extensions[key] !== undefined ? this.extensions[key] : <any>null;
            }
        }
        return data;
    }

    clone(): ProblemDetails {
        const json = this.toJSON();
        let result = new ProblemDetails();
        result.init(json);
        return result;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions?: { [key: string]: any; };
}

export class AccessRequestModel implements IAccessRequestModel {
    featureNames?: string[] | null;
    locationId?: number;

    constructor(data?: IAccessRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["featureNames"])) {
                this.featureNames = [] as any;
                for (let item of _data["featureNames"])
                    this.featureNames!.push(item);
            }
            else {
                this.featureNames = <any>null;
            }
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : <any>null;
        }
    }

    static fromJS(data: any): AccessRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccessRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureNames)) {
            data["featureNames"] = [];
            for (let item of this.featureNames)
                data["featureNames"].push(item);
        }
        data["locationId"] = this.locationId !== undefined ? this.locationId : <any>null;
        return data;
    }

    clone(): AccessRequestModel {
        const json = this.toJSON();
        let result = new AccessRequestModel();
        result.init(json);
        return result;
    }
}

export interface IAccessRequestModel {
    featureNames?: string[] | null;
    locationId?: number;
}

export class AccessByStoreNumberRequestModel implements IAccessByStoreNumberRequestModel {
    featureNames?: string[] | null;
    storeNumber?: string | null;

    constructor(data?: IAccessByStoreNumberRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["featureNames"])) {
                this.featureNames = [] as any;
                for (let item of _data["featureNames"])
                    this.featureNames!.push(item);
            }
            else {
                this.featureNames = <any>null;
            }
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : <any>null;
        }
    }

    static fromJS(data: any): AccessByStoreNumberRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccessByStoreNumberRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureNames)) {
            data["featureNames"] = [];
            for (let item of this.featureNames)
                data["featureNames"].push(item);
        }
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : <any>null;
        return data;
    }

    clone(): AccessByStoreNumberRequestModel {
        const json = this.toJSON();
        let result = new AccessByStoreNumberRequestModel();
        result.init(json);
        return result;
    }
}

export interface IAccessByStoreNumberRequestModel {
    featureNames?: string[] | null;
    storeNumber?: string | null;
}

export class FeatureRequirementViewModel implements IFeatureRequirementViewModel {
    name?: string | null;
    key?: string | null;
    value?: string | null;
    status?: boolean;
    notes?: string | null;

    constructor(data?: IFeatureRequirementViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
        }
    }

    static fromJS(data: any): FeatureRequirementViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureRequirementViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        return data;
    }

    clone(): FeatureRequirementViewModel {
        const json = this.toJSON();
        let result = new FeatureRequirementViewModel();
        result.init(json);
        return result;
    }
}

export interface IFeatureRequirementViewModel {
    name?: string | null;
    key?: string | null;
    value?: string | null;
    status?: boolean;
    notes?: string | null;
}

export class UserAccessRequestModel implements IUserAccessRequestModel {
    locationId?: number;
    userId?: number;
    accountId?: number | null;

    constructor(data?: IUserAccessRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
        }
    }

    static fromJS(data: any): UserAccessRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserAccessRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId !== undefined ? this.locationId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        return data;
    }

    clone(): UserAccessRequestModel {
        const json = this.toJSON();
        let result = new UserAccessRequestModel();
        result.init(json);
        return result;
    }
}

export interface IUserAccessRequestModel {
    locationId?: number;
    userId?: number;
    accountId?: number | null;
}

export class UserAccessByStoreNumberRequestModel implements IUserAccessByStoreNumberRequestModel {
    storeNumber?: string | null;
    userId?: number;
    accountId?: number | null;

    constructor(data?: IUserAccessByStoreNumberRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
        }
    }

    static fromJS(data: any): UserAccessByStoreNumberRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserAccessByStoreNumberRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        return data;
    }

    clone(): UserAccessByStoreNumberRequestModel {
        const json = this.toJSON();
        let result = new UserAccessByStoreNumberRequestModel();
        result.init(json);
        return result;
    }
}

export interface IUserAccessByStoreNumberRequestModel {
    storeNumber?: string | null;
    userId?: number;
    accountId?: number | null;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}